type LogRocketRequest = {
  reqId: string
  method: string
  url: string
  body?: unknown
}

type LogRocketResponse = {
  reqId: string
  status?: number
  body?: unknown
}

const pendingRequests = new Map<string, string>()
const intentionallyCancelledRequests = new Set<string>()
const sensitiveRequests = new Set<string>()

const isServiceAccountsRequest = (url: string) =>
  /\/api\/parties\/[^/?#]+\/service-accounts(?:\/|$|[?#])/i.test(url)

const requestKey = (method: string, url: string) => {
  const normalizedUrl = url?.split(/[?#]/, 1)[0]
  return `${method?.toUpperCase()} ${normalizedUrl}`
}

export const trackLogRocketRequest = <T extends LogRocketRequest>(request: T) => {
  pendingRequests.set(request.reqId, requestKey(request.method, request.url))

  if (isServiceAccountsRequest(request.url)) {
    sensitiveRequests.add(request.reqId)
    return { ...request, body: null }
  }

  return request
}

export const markLogRocketRequestCancelled = (method: string, url: string) => {
  const cancelledKey = requestKey(method, url)

  for (const [reqId, key] of pendingRequests) {
    if (key === cancelledKey) {
      intentionallyCancelledRequests.add(reqId)
      break
    }
  }
}

export const filterLogRocketResponse = <T extends LogRocketResponse>(
  response: T,
) => {
  pendingRequests.delete(response.reqId)
  const isSensitive = sensitiveRequests.delete(response.reqId)

  const wasIntentionallyCancelled = intentionallyCancelledRequests.delete(
    response.reqId,
  )

  if (
    wasIntentionallyCancelled &&
    (response.status === 0 || response.status == null)
  ) {
    return null
  }

  if (isSensitive) {
    return { ...response, body: null }
  }

  return response
}
